import { useContext, useState, useRef, useEffect } from 'react';
import NhlGamesContext from './context/Context';
import './ThemeSelector.css';

const themes = [
  { id: 'default', name: 'Default' },
  { id: 'slate', name: 'Slate' },
  { id: 'ragedaddy', name: 'RageDaddy' },
  { id: 'mightyducks', name: 'Mighty Ducks' },
  { id: 'synthwave', name: 'Synthwave' },
  { id: '235', name: '235' }
];

const ThemeSelector = () => {
  const { theme, setTheme } = useContext(NhlGamesContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentTheme = themes.find(t => t.id === theme) || themes[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleThemeChange = (themeId) => {
    setTheme(themeId);
    setIsOpen(false);
  };

  return (
    <div className="theme-selector" ref={dropdownRef}>
      <button
        className="theme-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select theme"
      >
        <span className="theme-name">{currentTheme.name}</span>
        <span className={`theme-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>

      {isOpen && (
        <div className="theme-dropdown">
          {themes.map((t) => (
            <button
              key={t.id}
              className={`theme-option ${theme === t.id ? 'active' : ''}`}
              onClick={() => handleThemeChange(t.id)}
            >
              {t.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeSelector;
